import React, { PureComponent } from 'react'
import { Button } from 'react-bootstrap'
import NewPasswordFields, { isNewPasswordValid, toMessages } from './new_password_fields'

export const STEP_COLLAPSED = 'collapsed'
export const STEP_CODE_ENTRY = 'code_entry'
export const STEP_DONE = 'done'

export const LOGOUT_DELAY_MS = 3000

export class PasswordResetSection extends PureComponent {
  constructor(props) {
    super(props)
    this.state = {
      step: STEP_COLLAPSED,
      codeSentTo: null,
      code: '',
      newPassword: '',
      confirmPassword: '',
      requestError: null,
      codeErrors: [],
      passwordErrors: [],
    }
    this.logoutTimer = null
    this.mounted = true
  }

  componentWillUnmount() {
    this.mounted = false
    if (this.logoutTimer) {
      clearTimeout(this.logoutTimer)
    }
  }

  changeHandler = ({ target }) => this.setState({ [target.name]: target.value })

  sendCode = () => {
    const { email, requestPasswordResetCode } = this.props
    this.setState({ requestError: null, codeErrors: [], passwordErrors: [] })
    return requestPasswordResetCode({ email }).then(({ error }) => {
      if (!this.mounted) {
        return
      }
      if (error) {
        this.setState({ requestError: error })
        return
      }
      this.setState({ step: STEP_CODE_ENTRY, codeSentTo: email })
    })
  }

  openCodeEntry = () => this.setState({ step: STEP_CODE_ENTRY, codeSentTo: null, requestError: null })

  isSubmitEnabled = () => {
    const { code, newPassword, confirmPassword } = this.state
    return code.trim().length > 0 && isNewPasswordValid(newPassword, confirmPassword)
  }

  submit = () => {
    const { confirmPasswordReset, logoutUser } = this.props
    const { code, newPassword } = this.state
    this.setState({ requestError: null, codeErrors: [], passwordErrors: [] })
    return confirmPasswordReset({ code: code.trim(), new_password: newPassword }).then(({ error, details }) => {
      if (!this.mounted) {
        return
      }
      if (error) {
        const codeErrors = toMessages(details && details.code)
        const passwordErrors = (details && details.new_password) || []
        const hasFieldErrors = codeErrors.length > 0 || passwordErrors.length > 0
        this.setState({ requestError: hasFieldErrors ? null : error, codeErrors, passwordErrors })
        return
      }
      this.setState({ step: STEP_DONE, code: '', newPassword: '', confirmPassword: '' })
      this.logoutTimer = setTimeout(logoutUser, LOGOUT_DELAY_MS)
    })
  }

  renderCodeEntry() {
    const { isRequestingCode, isConfirming } = this.props
    const { codeSentTo, code, newPassword, confirmPassword, codeErrors, passwordErrors } = this.state
    return (
      <div>
        {codeSentTo && (
          <p id='code-sent-message'>
            We emailed <b>{codeSentTo}</b> — it may take a moment to arrive. Click the reset link in that email to
            finish, or paste the code from it below.{' '}
            <button
              type='button'
              id='resend-code'
              className='btn btn-link'
              disabled={isRequestingCode}
              onClick={this.sendCode}
            >
              {"Didn't get it? Send a new email"}
            </button>
          </p>
        )}
        <input
          id='reset-code'
          name='code'
          type='text'
          placeholder='Code from the email'
          className='form-control input-md'
          value={code}
          autoComplete='off'
          onChange={this.changeHandler}
        />
        {codeErrors.map((message, index) => (
          <div key={`${index}-${message}`} className='text-danger reset-code-error'>
            {message}
          </div>
        ))}
        <NewPasswordFields
          newPassword={newPassword}
          confirmPassword={confirmPassword}
          onChange={this.changeHandler}
          errors={passwordErrors}
        />
        <Button
          id='set-new-password'
          variant='primary'
          disabled={isConfirming || !this.isSubmitEnabled()}
          onClick={this.submit}
        >
          Set new password
        </Button>
      </div>
    )
  }

  render() {
    const { isRequestingCode } = this.props
    const { step, requestError } = this.state
    return (
      <div className='form-group'>
        <label className='col-md-4 control-label' htmlFor='send-reset-code'>
          Password
        </label>
        <div className='col-md-4'>
          {step === STEP_DONE ? (
            <p id='password-reset-done' className='text-success'>
              Password updated. Signing you out — please sign in with your new password.
            </p>
          ) : (
            <div>
              {step === STEP_COLLAPSED && (
                <div>
                  <Button id='send-reset-code' variant='primary' disabled={isRequestingCode} onClick={this.sendCode}>
                    Send reset code
                  </Button>
                  &nbsp;
                  <button type='button' id='have-code' className='btn btn-link' onClick={this.openCodeEntry}>
                    I already have a code
                  </button>
                </div>
              )}
              {step === STEP_CODE_ENTRY && this.renderCodeEntry()}
              <p id='password-reset-warning' className='text-warning'>
                Resetting your password will sign you out. Save any profile changes first.
              </p>
              {requestError && (
                <div id='password-reset-error' className='alert alert-danger'>
                  {requestError}
                </div>
              )}
            </div>
          )}
        </div>
      </div>
    )
  }
}

export default PasswordResetSection
